import Skeleton from '@mui/material/Skeleton'
import dayjs from 'dayjs'
import { useFdChatFieldwork } from '../../../../containers/Page/FdChat/FdChat.hooks'
import { USER_MAX_LENGTH_OF_INTERVIEW } from '../../../../containers/Page/FdChat/FdChat.model'
import { useFdChatProgress } from '../../FdChatProgressProvider.context'
import styles from './ProjectCost.module.css'

const ProjectCost = () => {
  const { interviewsWanted, loading: loadingProgress } = useFdChatProgress()
  const { fieldwork, fieldworkLoading } = useFdChatFieldwork()

  return (
    <div>
      <h2 className={styles.title}>Project cost</h2>
      <ul className={styles.list}>
        <li className={styles['list-item']}>
          <span>Completes</span>
          <span>
            {loadingProgress ? (
              <Skeleton variant="text" width={50} />
            ) : (
              interviewsWanted
            )}
          </span>
        </li>
        <li className={styles['list-item']}>
          <span>Length of interview</span>
          <span>{USER_MAX_LENGTH_OF_INTERVIEW} mins</span>
        </li>
        <li className={styles['list-item']}>
          <span>Fieldwork</span>
          <span>
            {fieldworkLoading ? (
              <Skeleton variant="text" width={50} />
            ) : (
              `${dayjs(fieldwork?.duration.endDate).diff(
                fieldwork?.duration.startDate,
                'days'
              )} days`
            )}
          </span>
        </li>
      </ul>
    </div>
  )
}

export default ProjectCost
